/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function checkUrlOpenCartLink() {
    const params = new URLSearchParams(window.location.search);
    if (params.has("opencart")) {
      console.log("Open Cart!")
      handleCartOpen();
      openCartLinkCleanup();
    } else {
      return false;
    }
  }

  function openCartLinkCleanup(){
    const currentUrl = window.location.href;
    if (currentUrl.indexOf('opencart') === -1) {
      return;
    }
    const baseUrl = currentUrl.split('?')[0];
    const paramsString = currentUrl.split('?')[1];
    const paramsArray = paramsString.split('&');
    const filteredParamsArray = paramsArray.filter(function(param) {
      return param.split('=')[0] !== 'opencart';
    });
    const filteredParamsString = filteredParamsArray.join('&');
    const newUrl = baseUrl + '?' + filteredParamsString;
    
    window.history.pushState({}, '', newUrl);
  }

  function handleCartOpen () {
    document.dispatchEvent(new CustomEvent('theme:product:added'));
  }

  checkUrlOpenCartLink()

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.



  $(document).on("swell:setup", function(){
    var existingEmailField = $('.rq-email-for-newsletters');
    var existingSubmitBtn = $(".newsletter__submit");

    $(existingSubmitBtn).click(function(){
      var email = existingEmailField.val();
      swellAPI.captureNewsletterSignup(email);
    });
  });


     /*RQ! add code for "Yotpo Slide-in cart integration" STARTS*/ 
   $(document).ready(function (e) {
    var pageURL = $(location).attr("href");
    var page_modify_tag = pageURL.split("#");
    var page_modify_tag_word = page_modify_tag[1]; 
    if(page_modify_tag_word == "get_product_subscription") {
      setTimeout(function () {
         $('html, body').animate({
              scrollTop: $(".get_product_subscription").offset().top  - 110
         }, 200);
       }, 1500);   
    }
    //$(".rq-modify-remove").click(function(){
     $('body').on('click', '.rq-modify-remove', function(){  
        var get_link =  $(this).attr('remove_product');
        setTimeout(function () {
          window.location.href = get_link+'#get_product_subscription';
        }, 3000);    
        $(this).closest(".cart__item").find(".cart__item__remove").trigger('click');
     });
    });
   /*RQ! add code for "Yotpo Slide-in cart integration" ENDS*/ 
   

})();

